import { AVIS_INICIALITZAR, AVIS_INTRODUCCIO_COMPROVAR } from '../../../../actions/actionTypes';

export const ESTAT_INICIAL = false;

const esDataBuida = data => data === undefined || data === null || data === '';

const data = (state = ESTAT_INICIAL, action) => {
    switch (action.type) {

        case AVIS_INICIALITZAR:
            return ESTAT_INICIAL;

        case AVIS_INTRODUCCIO_COMPROVAR: {
            const { data } = action.dades;
            return esDataBuida(data);
        }

        default:
            return state;
    }
};

export default data;



// WEBPACK FOOTER //
// ./src/reducers/avis/formulari/errors/data.js